import { useI18n } from 'vue-i18n'
import { useOptionsFormatter } from '@/composables/optionsFormatter'

export const registerBuildingTypeColumn = (dashboard, visible = true, showFilter = true) => {
  const { t } = useI18n()
  const { buildingTypeOptions } = useOptionsFormatter()

  dashboard.registerColumn({
    type: 'text',
    name: 'building_type',
    label: 'features.f_building_type',
    options: {
      format: (buildingType) => (buildingType ? t(`value.${buildingType}`) : ''),
      selectOptions: buildingTypeOptions,
      visible,
      showFilter,
      isMultiSelect: true,
    },
  })
}
